<!-- Page Banner -->
<div class="page-banner-area item-bg3">
    <div class="container">
        <div class="page-banner-content">
            <h2>Support and Maintenance Services</h2>
            <ul>
                <li>
                    <a href="/">Home</a>
                </li>
                <li>Support and Maintenance Services</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Banner -->
<!-- Services Details -->
<section class="services-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-image">
                    <img src="assets/img/services-details/services-details-1.jpg" alt="image">
                </div>

                <div class="services-details-desc">
                    <h3>Software Maintenance and Support Services We Offer</h3>
                    <p>Our IT support and maintenance services are designed to proactively handle the maintenance of
                        software to ensure it is
                        bug-free at deployment. We follow the best application software maintenance practices to make
                        your software robust and
                        secure. Our IT Support and maintenance services include -
                    </p>

                    <div class="services-details-features">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-12">
                                <div class="features-image">
                                    <img src="assets/img/services-details/services-details-2.jpg" alt="image">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <ul class="features-list">
                                    <li><i class="flaticon-check"></i> IMS Application Support Services</li>
                                    <li><i class="flaticon-check"></i> Application Maintenance and Support Services</li>
                                    <li><i class="flaticon-check"></i> Web Maintenance Services</li>
                                    <li><i class="flaticon-check"></i> SAP Support</li>
                                    <li><i class="flaticon-check"></i> Android App Maintenance Services</li>
                                    <li><i class="flaticon-check"></i> iOS App Maintenance Services</li>
                                    <li><i class="flaticon-check"></i> Remote IT Support Services</li>
                                    <li><i class="flaticon-check"></i> IT Support Services</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-details-information">
                    <ul class="services-list">
                        <li><a routerLink="/technology-expertise" class="active">Related Technology Expertise</a></li>
                        <li><a routerLink="/technology-expertise">Azure</a></li>
                        <li><a routerLink="/technology-expertise">AWD</a></li>
                        <li><a routerLink="/technology-expertise">Cloud Services</a></li>
                    </ul>

                    <app-services-contact-info></app-services-contact-info>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details -->

<!-- Services -->
<section class="services-area pb-70">
    <div class="container">
        <div class="section-title">
            <span>Services we provided</span>
            <h2>Related Services</h2>
            <div class="bar"></div>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/Infrastructure-management-services">
                            <img src="assets/img/services/services-7.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3><a routerLink="/Infrastructure-management-services">Infrastructure
                                & Service Management</a></h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="single-services-item">
                    <div class="image">
                        <a routerLink="/cloud-management-services">
                            <img src="assets/img/services/services-8.jpg" alt="image">
                        </a>
                    </div>
                    <div class="content">
                        <h3>
                            <a routerLink="/cloud-management-services">Cloud Services Management</a>
                        </h3>
                        <span>Contact us for more details</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services -->